import * as React from 'react';
import { Component } from 'react';
import { StatusBarComponent } from '../../controls/StatusBar';
import { IStatusBarInfo } from '../../models/IStatusBarInfo';
import { connect } from 'react-redux';


export function ShowStatusBar(type: 'Success' | 'Info' | 'Error', message: string, timeout?: number, actionMessage?: string, action?: () => void) {
    if (statusBarComponent !== null) {
        statusBarComponent.ShowStatusBar(type, message, timeout, actionMessage, action);
    }
}

//let statusBarInfo: IStatusBarInfo | null = null;
let statusBarComponent: GlobalStatusBarComponent | null = null;

function MapState(state) {
    return {
        StatusBarInfo: state.Status
    }
}

interface IProps {
    StatusBarInfo: IStatusBarInfo
}

class GlobalStatusBarComponent extends Component<IProps, any> {

    private StatusBarRef = React.createRef<StatusBarComponent>();

    constructor(props) {
        super(props);
    }

    public componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.StatusBarInfo !== undefined && nextProps.StatusBarInfo !== null) {
            this.ShowStatusBar(nextProps.StatusBarInfo.Type, nextProps.StatusBarInfo.Message, nextProps.StatusBarInfo.Timeout, nextProps.StatusBarInfo.ActionMessage, nextProps.StatusBarInfo.Action);
        }
    }

    public componentWillMount() {
        statusBarComponent = this;
    }

    public componentWillUnmount() {
        statusBarComponent = null;
    }

    public render() {
        return (
            <StatusBarComponent ref={this.StatusBarRef} />
        );
    }

    public ShowStatusBar(type: 'Success' | 'Info' | 'Error', message: string, timeout?: number, actionMessage?: string, action?: () => void) {
        if (this.StatusBarRef.current !== null) {
            this.StatusBarRef.current.ShowStatusBar(type, message, timeout, actionMessage, action);
        }
    }
}

export default connect(MapState)(GlobalStatusBarComponent);


// WEBPACK FOOTER //
// ./src/components/Layout/GlobalStatusBar.tsx